var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("CombateAFraudeLinks", { attrs: { professional: _vm.professional } }),
      _vm._v(" "),
      _c("Training", { attrs: { professionalId: _vm.professional.id } }),
      _vm._v(" "),
      [
        _c("v-data-table", {
          attrs: {
            headers: _vm.headers,
            items: _vm.events,
            "show-expand": "",
            "single-expand": "",
            "item-key": "step"
          },
          scopedSlots: _vm._u([
            {
              key: "item.events",
              fn: function(ref) {
                var headers = ref.headers
                var item = ref.item
                return [
                  _c("IconTooltip", {
                    attrs: {
                      options: _vm.getStatus(
                        _vm.eventName(item.events.slice(-1)[0].event_type)
                      )
                    }
                  }),
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm._f("getStatusName")(
                          _vm.eventName(item.events.slice(-1)[0].event_type)
                        )
                      ) +
                      "\n      "
                  )
                ]
              }
            },
            {
              key: "item.lastOccurency",
              fn: function(ref) {
                var headers = ref.headers
                var item = ref.item
                return [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.formattedDate(item.lastOccurency)) +
                      "\n      "
                  )
                ]
              }
            },
            {
              key: "expanded-item",
              fn: function(ref) {
                var headers = ref.headers
                var item = ref.item
                return [
                  _c(
                    "td",
                    { attrs: { colspan: headers.length } },
                    [
                      _vm.isOutOfRange(
                        _vm.eventName(item.events.slice(-1)[0].event_type)
                      )
                        ? _c("OutOfCoverage", {
                            attrs: { professional: _vm.professional }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isCreatedStep(
                        _vm.eventName(item.events.slice(-1)[0].event_type)
                      )
                        ? _c("Created", {
                            attrs: { professional: _vm.professional }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isDocumentsValidationStep(
                        _vm.eventName(item.events.slice(-1)[0].event_type)
                      )
                        ? _c("DocumentValidation", {
                            attrs: {
                              professional: _vm.professional,
                              events: item.events
                            },
                            on: {
                              refresh: function($event) {
                                return _vm.$emit("refresh")
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isBackgroundcheckValidationStep(
                        _vm.eventName(item.events.slice(-1)[0].event_type)
                      )
                        ? _c("BackgroundCheckValidation", {
                            attrs: {
                              professional: _vm.professional,
                              events: item.events
                            },
                            on: {
                              refresh: function($event) {
                                return _vm.$emit("refresh")
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isPgaValidationStep(
                        _vm.eventName(item.events.slice(-1)[0].event_type)
                      )
                        ? _c("PGA", {
                            attrs: {
                              professional: _vm.professional,
                              events: item.events
                            },
                            on: {
                              refresh: function($event) {
                                return _vm.$emit("refresh")
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isAccessDeniedValidationStep(
                        _vm.eventName(item.events.slice(-1)[0].event_type)
                      )
                        ? _c("AccessDenied", {
                            attrs: {
                              professional: _vm.professional,
                              events: item.events
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              }
            }
          ])
        })
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ff17ac5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ff17ac5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Professionals/Edit/Tabs/Register/Index.vue
// module id = null
// module chunks = 